<template>
	<div class="template time-slot">
		<div class="panel_wrap">
			<div class="file-wrap-title">使用设备<span class="require">*</span> </div>
			<div class="input_value">
				<el-select @change="OptionUpdate(value1)" v-model="value1" placeholder="请选择">
					<el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.name"></el-option>
				</el-select>
			</div>
		</div>
		<div class="equipment-list">
			<div class="equipment-part" v-for="(item,index) in equipment" :key="index">
				<div class="equipment-name">{{item.time}}{{item.week}}</div>
				<div class="equipment-time">
					<div v-for="(val,idx) in item.timeLine" :data-time='val.time' :data-value="val.str" @click="clickTimePoint(index,idx,$event)"
					 :class="max >= val.time && !val.class && index == 0?'disabled':val.class" :key="index+idx" :style="'width:'+ 100/item.timeLine.length  +'%'">
						<span v-if="idx == 0">{{start}}</span>
						<!-- <span v-if="parseInt(val.time) == val.time && idx != (item.timeLine.length-1) && idx != 0">{{val.time}}</span> -->
						<span v-if="parseInt(val.time) == val.time">{{val.time}}</span>
						<span v-if="idx == (item.timeLine.length-1)">{{end}}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="equipment-tips" v-show="tipsType == 1" :style="{ left: tips.left+'px', top: tips.top + 'px' }">
			<div class="equipment-tips-time">{{tips.string}} {{tips.time}} </div>
			<div class="equipment-tips-opt">
				<span class="cancel" @click="close">关闭</span>
			</div>
		</div>
		<div class="equipment-tips" v-show="tipsType == 2" :style="{ left: tips.left+'px', top: tips.top + 'px' }">
			<div class="equipment-tips-time">{{tips.string}} {{tips.time}} </div>
			<div class="equipment-tips-opt">
				<span class="cancel" @click="cancelCurrent">取消</span>
				<span class="confirm" @click="close">关闭</span>
			</div>
		</div>
		<div class="equipment-tips" v-show="tipsType == 3" :style="{ left: tips.left+'px', top: tips.top + 'px' }">
			<!-- <div class="equipment-tips-title" v-if="click.title">{{click.title}}</div> -->
			<div class="equipment-tips-time">{{click.string}}</div>
			<div class="equipment-tips-opt">
				<span class="cancel" @click="cancelApply">取消</span>
				<span class="confirm" @click="configApply">确定</span>
			</div>
		</div>
		<!--		<div class="config" @click="defineTime">-->
		<!--			确定-->
		<!--		</div>-->
	</div>
</template>

<script>
	import {
		getResourceBorrowingInfoByArticle,
	} from "@/api/ResourceBorrowing";
	export default {
		props: ['dataVal', 'optionVal', 'userInfo','value1'],
		data() {
			return {
				// value1: "①小米笔记本",
				start: 9,
				end: 22,
				step: 0,
				options: [],
				equipment: [],
				timeLine: [],
				tipsType: 0, //0:不显示，1 、已经申请过，确定的 2、要申请，但还未申请的 3、空白时间点
				tips: {
					left: 0,
					top: 0,
					time: '',
					start: 0,
					end: 0,
					string: '',
					index: null
				},
				click: {},
				self: 'SC17008402',
				name: '邓邓',
				equipmentVal: null,
				falg:0,
				max:0
			}
		},
		mounted() {
			this.initData()
			this.funDate();
		},
		created() {},
		methods: {
			/**
			 * 选中中时触发
			 * */
			OptionUpdate: async function(value) {
				this.$emit('select-update', value, 'update')
				await getResourceBorrowingInfoByArticle(value, 0).then(res => {
					this.equipmentVal = res.Body
					this.funDate();
				})

			},
			funDate() {
				if (this.userInfo !== undefined && this.equipmentVal !== null) {
					this.fun_date(7)
				} else {
					setTimeout(() => this.funDate(), 100)
				}
			},
			/**
			 * time 2021-06-01
			 * used: [{
			 time:'9:00-15:00',
			 name:'zhangsan',
			 empno:'SC17008402'
			 }]
			 * @param aa
			 */
			fun_date(aa) {
				this.equipment = []
				var date1 = new Date(),
					month = date1.getMonth() + 1,
					day = date1.getDate(),
					time1 = date1.getFullYear() + "-" + (month <= 9 ? '0' + month : month) + "-" + (day <= 9 ? '0' + day : day);
				this.equipment.push({
					time: time1,
					week: this.getWeekDate(time1),
					used: []
				})

				for (var i = 1; i < aa; i++) {
					var date2 = new Date(date1);
					date2.setDate(date1.getDate() + i);
					var month2 = date2.getMonth() + 1,
						day2 = date2.getDate()
					var time2 = date2.getFullYear() + "-" + (month2 <= 9 ? '0' + month2 : month2) + "-" + (day2 <= 9 ? '0' + day2 :
						day2);
					this.equipment.push({
						time: time2,
						week: this.getWeekDate(time2),
						used: []
					})
				}
				for (let j = 0; j < this.equipment.length; j++) {
					let data = this.equipment[j]
					let fil = this.equipmentVal.filter(e => e.time === data.time)
					if (fil.length > 0) {
						data.used = fil[0].used
					}
				}
				this.timeLineFn();
				// return time2;
			},
			initData: async function() {
				await getResourceBorrowingInfoByArticle(this.value1, 0).then(res => {
					this.equipmentVal = res.Body
					this.options = this.optionVal
					this.self = this.userInfo.EmpNo
					this.name = this.userInfo.EmpName
				})
			},
			getWeekDate(time) {
				var now = new Date(time);
				var day = now.getDay();
				var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
				var week = weeks[day];
				return week;
			},
			getMinute(index) {
				index = index - 1
				let minuteTotal = (9 * 60) + (index * 30);
				let time = parseInt(minuteTotal / 60);
				let minute = minuteTotal % 60;
				if (minute == 0) {
					return time + ':00';
				} else {
					return time + ':' + minute;
				}
			},
			timeLineFn() {
				this.step = (this.end - this.start) * 2;
				var timeLine = [];
				for (var i = 0; i < this.step; i++) {
					if (i == 0) {
						timeLine.push({
							time: 9,
							empno: '',
							class: '',
							name: '',
							str: this.getMinute(i + 1),
							timeStr: ''
						});
					} else if (i % 2 == 0) {
						timeLine.push({
							time: parseInt(i / 2) + 9,
							empno: '',
							class: '',
							name: '',
							str: this.getMinute(i + 1),
							timeStr: ''
						});
					} else {
						timeLine.push({
							time: parseInt(i / 2) + 9.5,
							empno: '',
							class: '',
							name: '',
							str: this.getMinute(i + 1),
							timeStr: ''
						});
					}
				}
				this.timeLine = timeLine;
				this.formatData();
			},
			arrangement(str) {
				let strArr = str.split('-'),
					startArr = strArr[0].split(':'),
					endArr = strArr[1].split(':'),
					start = 0,
					end = 0;
				if (parseInt(startArr[1]) == 0) {
					start = parseInt(startArr[0]);
				} else {
					start = parseFloat(startArr[0] + '.5');
				}
				if (parseInt(endArr[1]) == 0) {
					end = parseInt(endArr[0]);
				} else {
					end = parseFloat(endArr[0] + '.5');
				}
				return {
					start: start,
					end: end
				}
			},
			getNowTime(){
				let time = new Date(),house = time.getHours(),minute = time.getMinutes();
				if(minute > 0 && minute<=30){
					this.max = parseFloat(house);
				}else{
					this.max = parseFloat(house+1);
				}
			},
			// 格式转换
			formatData() {
				this.getNowTime();
				this.equipment.forEach((item, index) => {
					var line = [],
						timeLine = JSON.stringify(this.timeLine);
					var newTimeLine = JSON.parse(timeLine);
					if (item.used && item.used.length != 0) {
						for (var i = 0, len = item.used.length; i < len; i++) {
							let result = this.arrangement(item.used[i].time)
							// console.log(result)
							this.$set(item.used[i], 'start', result.start);
							this.$set(item.used[i], 'end', result.end - 0.5);
							if (item.used[i].empno == this.self) {
								this.$set(item.used[i], 'class', 'myself');
							} else if (item.used[i].empno && item.used[i].empno != this.self) {
								this.$set(item.used[i], 'class', 'other');
							} else {
								this.$set(item.used[i], 'class', '');
							}
							newTimeLine.forEach(value => {
								if (value.time >= result.start && value.time <= result.end - 0.5) {
									value.empno = item.used[i].empno;
									value.name = item.used[i].name;
									value.timeStr = item.used[i].time;
									if (item.used[i].empno == this.self) {
										value.class = 'myself'
									} else if (item.used[i].empno && item.used[i].empno != this.self) {
										value.class = 'other'
									}
								}

							})
						}
						// console.log(newTimeLine)
						this.$set(item, 'timeLine', newTimeLine);
					} else {
						this.$set(item, 'timeLine', JSON.parse(JSON.stringify(this.timeLine)));
					}
				});
			},
			// 操作
			clickTimePoint(index, idx, event) {
				let data = this.equipment[index]
				let timeLine = this.equipment[index].timeLine;
				let value = this.equipment[index].timeLine[idx];
				let clientWidth = document.body.clientWidth,
					left = 0,
					top = event.pageY + 10;
				if (event.pageX <= 220) {
					left = 15;
				} else if (event.pageX + 220 > clientWidth) {
					left = clientWidth - 220;
				} else {
					left = event.pageX - 110;
				}
				this.$set(this.tips, 'left', left);
				this.$set(this.tips, 'top', top);
				this.$set(this.tips, 'string', value.name + '已申请 ');
				this.$set(this.tips, 'time', value.timeStr);
				this.$set(this.tips, 'index', index);
				if (value.empno && value.class != 'current') {
					// 其他人的选择和当前用户之前的选择（已经申请过，确定的）
					timeLine.forEach(item => {
						if (item.time >= this.click.start && item.time <= this.click.end - 0.5) {
							item.class = '';
							item.name = '';
							item.empno = '';
							item.timeStr = '';
						}
					})
					this.tipsType = 1;
				} else if (value.empno && value.class == 'current') {
					//当前用户点击要申请，但还未申请的
					let time = this.arrangement(value.timeStr);
					timeLine.forEach(item => {
						if (item.time >= this.click.start && item.time <= this.click.end - 0.5) {
							item.class = '';
							item.name = '';
							item.empno = '';
							item.timeStr = '';
						}
					})
					this.$set(this.tips, 'start', time.start);
					this.$set(this.tips, 'end', time.end);
					this.tipsType = 2;
				} else {
					//空白时间段
					let Time = `${data.time} ${value.str}`
					if (new Date(Time) < new Date()) {
						return false
					}
					this.showTipsNow(index, idx, event)

				}
			},
			// 空白时间段
			showTipsNow(index, idx, event) {
				let timeLine = this.equipment[index].timeLine;
				let value = this.equipment[index].timeLine[idx];
				if (value.class != '') {
					// console.log(this.click)
					timeLine.forEach(item => {
						if (item.time >= this.click.start && item.time <= this.click.end-0.5) {
							item.class = '';
							item.name = '';
							item.empno = '';
							item.timeStr = '';
						}
					})
					alert('你选择的时间段已经被选择了');
					this.tips = {};
					this.click = {};
					this.tipsType = 0;
					return;
				}

				if (this.click.index == null) {
					this.click.index = index;
					this.click.start = value.time;
					this.click.end = value.time + 0.5;
					this.click.empno = this.self;
					let time = '';
					if (parseInt(value.time) == value.time) {
						time = (value.time) + ':00-' + (parseInt(value.time)) + ':30';
					} else {
						time = parseInt(value.time) + ':30-' + parseInt(value.time+0.5) + ':00';
					}
					this.click.time = time;
					this.click.string = '是否确定选择' + time + '这段时间';
					value.class = 'current';
					value.name = this.name;
					value.empno = this.self;
					value.timeStr = time;
					this.tipsType = 3;
				} else if (this.click.index == index) {
					timeLine.forEach(item => {
						if (item.time >= this.click.start && item.time <= this.click.end-0.5) {
							item.class = '';
							item.name = '';
							item.empno = '';
							item.timeStr = '';
						}
					})
					var used = this.equipment[index].used;
					for (var i = 0; i < used.length; i++) {
						if (value.time <= used[i].end-0.5 && this.click.start >= used[i].start) {
							alert('你选择的时间段已经被申请了');
							this.tips = {};
							this.click = {};
							this.tipsType = 0;
							return;
						}
						if (value.time > used[i].end-0.5 && this.click.start <= used[i].start) {
							alert('你选择的时间段已经被申请了');
							this.tips = {};
							this.click = {};
							this.tipsType = 0;
							return;
						}
					}
					let time = '',
						start = '',
						end = '',
						convert = 0;
					if (value.time > this.click.end) {
						this.click.end = value.time;
					} else if (value.time < this.click.start) {
						this.click.start = value.time;
						if(this.falg == 0){
							this.click.end = this.click.end-0.5;
							this.falg = 1;
						}
						
					} else {
						// this.click.end = value.time+0.5;
						this.click.end = value.time;
					}
					this.click.empno = this.self;
					if (this.click.start == parseInt(this.click.start)) {
						start = parseInt(this.click.start) + ':00';
					} else {
						start = parseInt(this.click.start) + ':30';
					}
					if (this.click.end+0.5 == parseInt(this.click.end+0.5)) {
						end = parseInt(this.click.end+0.5) + ':00';
					} else {
						end = parseInt(this.click.end+0.5) + ':30';
					}
					time = start + '-' + end;
					this.click.time = time;
					this.click.string = '是否确定选择' + time + '这段时间';
					value.timeStr = time;
					timeLine.forEach(item => {
						if (item.time >= this.click.start && item.time <= this.click.end) {
							item.class = 'current';
							item.name = this.name;
							item.empno = this.self;
							item.timeStr = time;
						}
					})
					this.tipsType = 3;
				} else {
					this.cancelApply()
				}

			},
			// 关闭
			close() {
				this.tipsType = 0;
				this.tips = {};
				this.falg = 0;
			},
			//取消本次已经确定的
			cancelCurrent() {
				let arr = this.equipment[this.tips.index].timeLine;
				arr.forEach(item => {
					if (item.time >= this.tips.start && item.time <= this.tips.end-0.5) {
						item.class = '';
						item.name = '';
						item.empno = '';
						item.timeStr = '';
					}
				})
				let used = this.equipment[this.tips.index].used;
				for (var i = 0, len = used.length; i < len; i++) {
					if (used[i].start == this.tips.start && used[i].end == this.tips.end-0.5) {
						this.equipment[this.tips.index].used.splice(i, 1);
					}
				}
				this.click = {}
				this.tipsType = 0;
				this.tips = {};
				this.falg = 0;
			},
			// 取消
			cancelApply() {
				let arr = this.equipment[this.click.index].timeLine;
				// debugger
				arr.forEach(item => {
					if (item.time >= this.click.start && item.time <= this.click.end) {
						item.class = '';
						item.name = '';
						item.empno = '';
						item.timeStr = '';
					}
				})
				this.equipment[this.click.index].timeLine = arr;
				this.click = {}
				this.tipsType = 0;
				this.tips = {};
				this.falg = 0;
			},
			// 确定
			configApply() {
				let arr = this.equipment[this.click.index];
				this.equipment[this.click.index].used.push({
					name: this.name,
					empno: this.self,
					time: this.click.time,
					start: this.click.start,
					end: this.click.end,
					timeStr: this.click.time,
					class: 'current'
				})
				this.click = {}
				this.tipsType = 0;
				this.tips = {};
				this.falg = 0;
			},
			// 获取本次选择的时间段
			defineTime() {
				let time = [];
				this.equipment.forEach(item => {
					if (item.used.length != 0) {
						for (var i = 0, len = item.used.length; i < len; i++) {
							if (item.used[i].class == 'current') {
								time.push({
									day: item.time,
									time: item.used[i].time
								});
							}
						}
					}
				})
				this.$emit('submit-val', time, 'submit');
				this.formatData();
			}
		}
	}
</script>

<style>
	@import "../assets/css/common.css";

	.config {
		margin: 30px 40px;
		height: 36px;
		line-height: 36px;
		font-size: 13px;
		text-align: center;
		color: #FFFFFF;
		background: #2D8CF0;
		border-radius: 4px;
	}

	.time-slot .file-wrap-title {
		display: block;
		float: left;
		width: 124px;
		line-height: 30px;
	}

	.time-slot .panel_wrap .el-input__prefix {
		display: none !important;
	}

	.time-slot .input_value .el-input__inner {
		height: 30px;
		line-height: 30px;
		text-align: right;
		border: none;
	}

	.time-slot .input_value .el-input--suffix .el-input__inner {
		padding-right: 30px;
		padding-left: 10px;
	}

	.time-slot .input_value .el-select .el-input__icon {
		line-height: normal;
	}

	.equipment-list {
		text-align: left;
		padding: 0 15px;
	}

	.equipment-part {
		padding-bottom: 10px;
	}

	.equipment-time {
		width: 100%;
		/* display: -webkit-box; */
		padding-bottom: 18px;
		overflow: hidden;
	}

	.equipment-time div {
		border: 1px solid #ccc;
		display: block;
		border-left: 0;
		height: 22px;
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		position: relative;
		float: left;
	}

	.equipment-time div:first-child {
		border-left: 1px solid #ccc;
	}

	.equipment-time div span {
		position: absolute;
		/* left: -7px; */
		left: -9px;
		bottom: -20px;
		font-size: 12px;
		color: #bbb;
	}

	.equipment-time .other {
		background: #DDDDDD;
	}

	.equipment-time .myself {
		background: #cdf0ff;
	}
	.equipment-time .disabled {
		background: #f3f3f3;
	}
	
	.equipment-time .myself {
		background: #cdf0ff;
	}

	.equipment-time .current {
		background: rgba(5, 184, 248, 0.55);
	}

	.equipment-time div:first-child span {
		left: -2px;
	}

	.equipment-time div:last-child span {
		left: 4px;
	}

	.equipment-tips {
		position: absolute;
		background: #fff;
		box-shadow: 4px 4px 14px #2d8cf0;
		padding: 4px 0px;
	}

	.equipment-tips-title {
		line-height: 28px;
		font-size: 14px;
		color: #000000;
		padding: 0 15px;
	}

	.equipment-tips-time {
		line-height: 26px;
		font-size: 12px;
		color: #555;
		padding: 0 15px;
	}

	.equipment-tips-opt {
		padding: 4px 10px 4px 30px;
		text-align: right;
	}

	.equipment-tips-opt span {
		display: inline-block;
		padding: 2px 14px;
		font-size: 12px;
		border: 1px solid #ddd;
		border-radius: 2px;
		margin-left: 10px;
	}

	.equipment-tips-opt span.confirm {
		color: #fff;
		background: #2d8cf0;
		border-color: #2d8cf0;
	}

	.template {
		-webkit-appearance: none;
	}
</style>
